const newEquipment = {
  plant: "Edificio",
  equipment: "Crear un Nuevo Activo",
  backbtn: "Atrás",
  modulesButton: "Módulos",
  equipmentTag: "Tag de Activo",
  mechanical: "Código de Sello Mecánico",
  customer: "Cliente",
  equipmentType: "Tipo de Activo",
  typeContract: "Tipo de Contrato",
  equipmentStatus: "Estatus del Activo",
  statuslights: {
    running: "En Servicio",
    standby: "En Reposo",
    maintenance: "En Mantenimiento",
    failure: "Fallando"
  },
  tabs: {
    info: "INFORMACION BÁSICA",
    values: "VALORES OPERACIONALES",
    ranges: "RANGOS DE VARIABLE"
  },
  area: "Área",
  unit: "Unidad",
  location: "Seleccionar Ubicación",
  selectPlant: "Seleccionar Edificio",
  selectArea: "Seleccionar Área",
  selectUnit: "Seleccionar Unidad",
  sealTypes: "Tipo de sello mecánico",
  hazardous: "Clasificación de área peligrosa",
  createdBy: "Creado Por",
  dateCreated: "Fecha de Creación",
  comment: "Comentario",
  pumpHousing: "Carcasa de la bomba",
  deleteEquipment: "Eliminar activo",
  snackText: "Su activo se ha creado con éxito",
  submit: "Enviar",
  picture: "Imagen",
  machineHealthIndex: "Índice de Salud del Activo",
  mechanicalCondition: "Condición Mecánica del Activo",
  manufacturer: "Fabricante",
  model: "Modelo",
  selectLocation: "Seleccionar Ubicacion"
};
export default newEquipment;
